import { render, staticRenderFns } from "./listpeserta.vue?vue&type=template&id=5d6ad8e6&"
import script from "./listpeserta.vue?vue&type=script&lang=js&"
export * from "./listpeserta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports